import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useVideoContext } from 'hooks';

export default function AudioTrack({ track }) {
  const { settings } = useVideoContext();
  const { audioOutputId } = settings;
  const audioEl = useRef();

  useEffect(() => {
    audioEl.current = track.attach();
    document.body.appendChild(audioEl.current);
    return () =>
      track.detach().forEach((el) => {
        el.remove();
        // eslint-disable-next-line no-param-reassign
        el.srcObject = null;
      });
  }, [track]);

  useEffect(() => {
    audioEl.current?.setSinkId?.(audioOutputId);
  }, [audioOutputId]);

  return null;
}

AudioTrack.propTypes = {
  track: PropTypes.objectOf(PropTypes.any),
};

AudioTrack.defaultProps = {
  track: null,
};
